module.exports = [
  { id: "for-students", value: "For Students" },
  { id: "for-teachers", value: "For Teachers" },
  { id: "for-parents", value: "For Parents" },
  { id: "for-leaders", value: "For Leaders" },
];
